import { ShortLinkRedirectPage } from "./ShortLinkRedirectPage";

export default ShortLinkRedirectPage;
